module.exports = __webpack_public_path__ + "static/media/alishan_package.f3647b68.png";